export default "__VITE_ASSET__qzWMA0UI__"